module.exports = __webpack_public_path__ + "img/banner-desc.e0b89dc6.png";